import React from 'react';
import RcDropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css'; // Import the default styles
import styles from './rcDropdown.module.css'; // Import your CSS module

const NotificationDropdown = ({ renderFunc=<></>,childComp=null, icon="bell", event="hover"}) => {


  return (
    <RcDropdown overlay={renderFunc} trigger={[event]} >
        {childComp}
    </RcDropdown>
  );
};

export default React.memo(NotificationDropdown);
